<template>
  <v-app-bar
    dir="rtl"
    class="tw-top-0 !tw-fixed tw-overflow-visible !tw-border-b"
    elevation="0"
  >
    <div :dir="$root.$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="tw-flex tw-justify-between tw-w-full tw-px-3">
      <div class="tw-flex tw-items-center tw-gap-2">
        <a-button @click="isActive = !isActive" icon="solar:hamburger-menu-broken" intent="icon" icon-class="!tw-text-2xl" class="tw-rounded-lg"></a-button>

        <GlobalSearch v-if="false" />
      </div>

      <div class="tw-flex tw-items-center tw-gap-2">

        <BaseButtonHeader v-if="false" />

        <UserBadge v-if="authStore.user.role == 'marketer'" />
        
        <LanguageSwitcher />

        <UserNotification />

        <UserMenu />
      </div>
    </div>
  </v-app-bar>
</template>

<script setup>
import LanguageSwitcher from "./header/LanguageSwitcher";
import BaseButtonHeader from "./header/BaseButtonHeader";
import UserNotification from "./header/UserNotification";
import GlobalSearch from "./header/GlobalSearch";
import UserMenu from "./header/UserMenu";
import UserBadge from "./header/UserBadge";
import { useAuthStore } from '@/stores';

import { defineProps, defineEmits, computed } from "vue";

const authStore = useAuthStore();
const emit = defineEmits(["update:drawer"]);
const props = defineProps({
  drawer: {
    required: true,
  },
});

const isActive = computed({
  get: () => props.drawer,
  set: (v) => emit("update:drawer", v),
});
</script>

<style>
</style>